import Vue from 'vue'
import App from './App.vue'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Resume from './views/Resume.vue'
import Portfolio from './views/Portfolio.vue'
import Contact from './views/Contact.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faHome, faUser, faPortrait, faFileAlt, faFolderOpen, faMobile, faEnvelope, faMapMarkedAlt
} from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faGithub, faGithubSquare } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import { CarouselPlugin } from 'bootstrap-vue'
import { WOW } from 'wowjs'

library.add(
  faHome,
  faUser,
  faPortrait,
  faFileAlt,
  faFolderOpen,
  faMobile,
  faEnvelope,
  faMapMarkedAlt,
  faLinkedin,
  faGithub,
  faGithubSquare
  )


Vue.component('fa', FontAwesomeIcon)
Vue.component('home', Home)
Vue.component('about', About)
Vue.component('resume', Resume)
Vue.component('portfolio', Portfolio)
Vue.component('contact', Contact)
// Vue.use(CarouselPlugin)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')

new WOW().init();